module.exports = __webpack_public_path__ + "static/media/rotor_placed.9c22cf44.svg";